export default __webpack_public_path__ + "static/media/phonebgmobile.2723627a.svg";